var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('el-button', {
    staticClass: "search-hd",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword(_vm.keyword)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-bd"
  }, [_c('search-bar', {
    attrs: {
      "ajaxSearch": false,
      "placeholder": "请输入职位名称、职位编号、招聘HR进行搜索"
    },
    on: {
      "enter-key": _vm.searchKeyword,
      "select": _vm.searchKeyword
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('filter-panel', {
    ref: "condition",
    on: {
      "params-change": _vm.handleParmasChange
    }
  }, _vm._l((_vm.filterConf), function(item, index) {
    return _c('filter-panel-item', {
      key: index,
      ref: item.name,
      refInFor: true,
      attrs: {
        "label": item.label,
        "mode": item.mode,
        "visible": item.visible,
        "name": item.name,
        "data": item.data,
        "initValue": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header mt-15 clearfix"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '1')
      }
    }
  }, [_vm._v("发布\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '2')
      }
    }
  }, [_vm._v("待定\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.toggleState(_vm.idStr, '4')
      }
    }
  }, [_vm._v("不通过\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "职位编号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位名称",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#20A0FF"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.preview.show(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 722025121)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityNames",
      "label": "工作地点",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptNames",
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘范围",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_PROPERTY_TYPE', scope.row.property)) + "\n                        ")]
      }
    }], null, false, 3894185378)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "门户展示",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.showInDesk == 1 ? '是' : '否') + "\n                        ")]
      }
    }], null, false, 3889521821)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内推职位",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_YES_OR_NO', scope.row.recommendable)) + "\n                        ")]
      }
    }], null, false, 403392328)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审批人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.apploverName || '-') + "\n                        ")]
      }
    }], null, false, 3126854548)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核时间",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.apploveTime || '-') + "\n                        ")]
      }
    }], null, false, 4061322964)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "followUpName",
      "label": "跟进人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(['草稿', '已发布', '暂停', '待审核', '不通过'][scope.row.state]) + "\n                        ")]
      }
    }], null, false, 2224556558)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 1)
            }
          }
        }, [_vm._v("发布")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 2)
            }
          }
        }, [_vm._v("暂停")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.toggleState(scope.row.id, 4)
            }
          }
        }, [_vm._v("不通过")])]
      }
    }], null, false, 2617036016)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('preview-position', {
    ref: "preview"
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1375ed46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/reviewList.vue
// module id = null
// module chunks = 